import { Box } from "@theme/components";

import type { FC } from "react";

export const DropdownDivider: FC = () => (
  <Box role="separator" sx={{ height: "1px", mx: "s200", bg: "borderLevel3" }} />
);
